import { ErrorMessage, Label, Tag } from '@common-web/index';
import { Flex } from 'antd';

const TagsSelect = ({
  label = '',
  list = [],
  errorMsg = '',
  value = [],
  valueKey = null,
  displayKey = null,
  onChange,
  required = false,
  tagClassName = '',
  onClick = () => {},
  disabled = false,
}) => {
  return (
    <div>
      {label && <Label required={required}>{label}</Label>}
      <Flex wrap gap={8}>
        {list?.map((item) => {
          const tagName = item?.[displayKey] ?? item?.[valueKey] ?? item;
          const valueName = item?.[valueKey] ?? item;
          return (
            <Tag
              handleChange={async (value, checked) => {
                onChange(value, checked, item);
              }}
              onClick={() => onClick(item)}
              checked={value?.includes(valueName)}
              value={tagName}
              key={item}
              className={tagClassName}
              suffix={item?.suffix}
              disable={disabled}
            />
          );
        })}
      </Flex>
      <ErrorMessage errorMsg={errorMsg} />
    </div>
  );
};

export default TagsSelect;
